import {parseJSON} from 'date-fns'
import {zonedTimeToUtc,utcToZonedTime,format} from 'date-fns-tz'


function convert(date,tz){
  if ((typeof date)=='string'){
    date = parseJSON(date);
  }
  if (tz){
    date = utcToZonedTime(date,tz);
  }
  return date;
}

export default {
  methods: {
    //don't use this anymore.  It's impossible to figure out from the calling
    //code which format is being applied. Also it doesn't convert it to the configured time zone.
    //Instead, create and use corresponding functions below, such as fullDate.
    formatDate(date, longForm = false, showDay = false, fullDate = false) {
      if (!date){
        return '';
      }
      if ((typeof date)=='string'){
        date = parseJSON(date);
      }
      if (fullDate) {
        return format(date,"EEEE MMMM-d-yyyy h:mm aaaaa'm' z");
      } else if (showDay) {
        return format(date,"EE MMM-d-yyyy h:mm aaaaa'm' z");
      } else if (longForm) {
        return format(date,"MM/dd/yyyy h:mm aaaaa'm'");
      }
      return format(date,'MM/dd/yyyy');
    },
    formatDateTime(date) {
      if (!date){
        return '';
      }
      if ((typeof date)=='string'){
        date = parseJSON(date);
      }
      return format(date,"MM/dd/yyyy h:mm aaaaa'm'");
    },
    formatDateTime2Lines(date) {
      if (!date){
        return '';
      }
      if ((typeof date)=='string'){
        date = parseJSON(date);
      }
      return `${format(date,"MMM&#8209;d")}&nbsp;<span class="small">${format(date,"yyyy")}</span><br><span class="small">${format(date,"h:mm aaaaa'm'")}</span>` ;

    },
    fullDate(date,tz){
      if (!date){
        return '';
      }
      date = convert(date,tz);
      return format(date,"EEEE MMMM-d-yyyy h:mm aaaaa'm' z");
    },
    shortDate(date,tz){
      if (!date){
        return '';
      }
      date = convert(date,tz);
      return format(date,'MM/dd/yyyy');
    },   
  }
}



